import { useState } from 'react'
import { Button, InputNumber, Space } from 'antd'

type Props = {
  salesGoal: number | null
  onSave: (salesGoal: number | null) => void
}

const RevenueQuickFix = ({ salesGoal, onSave }: Props) => {
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState<number | null>(salesGoal)

  if (!editing) {
    return (
      <Button
        size="small"
        onClick={() => {
          setDraft(salesGoal)
          setEditing(true)
        }}
      >
        Fix the revenue
      </Button>
    )
  }

  return (
    <Space size="small" wrap>
      <InputNumber
        autoFocus
        prefix="$"
        value={draft}
        onChange={setDraft}
        min={0}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ''))}
        style={{ width: '160px' }}
        aria-label="Estimated revenue this year"
      />
      <Button
        size="small"
        type="primary"
        onClick={() => {
          onSave(draft)
          setEditing(false)
        }}
      >
        Save
      </Button>
      <Button size="small" type="text" onClick={() => setEditing(false)}>
        Cancel
      </Button>
    </Space>
  )
}

export default RevenueQuickFix
